export type TGA4Context = {
  initGaLogin: Function;
};

export enum GA4LoginSource {
  'apple' = 'apple',
  'google' = 'google',
  'vibo' = 'vibo',
}
